module.exports = __webpack_public_path__ + "img/1608976088.c7f88499.png";